import { useId } from 'react';

import classes from './KaliOutline.module.css';

export default function KaliOutline({ variant }: { variant: 'field' | 'sidebar' }) {
  const id = useId();
  const pathId = `${id}-path`;
  const maskId = `${id}-mask`;

  return (
    <svg className={`${classes.outline} ${classes[variant]}`} aria-hidden='true' focusable='false'>
      <defs>
        <rect id={pathId} className={classes.path} pathLength='100' fill='none' />
        <mask id={maskId} maskUnits='userSpaceOnUse' x='0' y='0' width='100%' height='100%'>
          <use href={`#${pathId}`} stroke='white' strokeWidth='2.25' />
        </mask>
      </defs>
      <use href={`#${pathId}`} stroke='var(--mantine-color-blue-4)' strokeOpacity={0.55} strokeWidth='1.25' />
      <g mask={`url(#${maskId})`}>
        <g className={classes.trail}>
          <use href={`#${pathId}`} stroke='var(--mantine-color-blue-4)' strokeDasharray='12 88' />
          <use href={`#${pathId}`} stroke='var(--mantine-color-violet-6)' strokeDasharray='0 10 10 80' />
        </g>
      </g>
    </svg>
  );
}
